/**
 * src/db/hero.db.js
 *
 * Datos de la sección Hero.
 */

import { uiIcons } from '@/shared/brandIcons.js'

export const heroData = {
    headline: 'UBIYAAA: transporte, negocios y servicios en Fusagasugá en un solo lugar',
    subheadline: 'Encuentra transporte particular, comercios, restaurantes, servicios profesionales y negocios locales en Fusagasugá desde una plataforma fácil, rápida y pensada para conectar a la ciudad.',
    ctas: [
        {
            label:   'Descargar App',
            href:    '/descargar',
            variant: 'secondary',
            icon:    uiIcons.download
        },
        {
            label:   'Explorar directorio',
            href:    '/directorio',
            variant: 'outline',
            icon:    uiIcons.compass
        },
        {
            label:   'Pedir transporte',
            href:    'https://wa.me/573124288323?text=Hola%2C%20quiero%20pedir%20transporte',
            variant: 'primary',
            icon:    uiIcons.car
        }
    ],
    media: {
        src:    '/hero-mockup.png',
        alt:    'App UBIYAAA en celular',
        badges: [
            { icon: '🚗', text: 'Transporte rápido' },
            { icon: '🏪', text: 'Negocios locales'  },
            { icon: '🎁', text: 'Promociones'        }
        ]
    },
    trust: [
        { value: '200+', label: 'Negocios registrados' },
        { value: '5K+',  label: 'Usuarios activos'     },
        { value: '4.8★', label: 'Calificación promedio' }
    ]
}
